<!DOCTYPE html>
<html lang="en">

<head>
	<script type="application/ld+json">

		{
		  "@context": "https://schema.org/",
		  "@type": "Organization",
		  "name": "Backseat Trader",
		  "url": "https://www.backseat-trader.com/",
		  "image": "https://www.backseat-trader.com/assets/img/Cosmic%20Algorithm%20Brand%20Assets-46.png"
		}
		
		</script>
	<meta charset="utf-8">
	<meta name="viewport" content="width=device-width, initial-scale=1.0">

	<title>Cosmic Algorithm's algorithm on the IBKR trading platform</title>
	<script src="js/wow.js"></script>
	<script>
		new WOW().init();
	</script>

	<link rel="shortcut icon" type="image/x-icon" href="assets/img/favicon.ico">
	<!--<link rel="stylesheet" type="text/css" href="assets/css/bundle.css">-->

	<link rel="preconnect" href="https://fonts.googleapis.com">
	<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="">
	<link
		href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&family=Poppins:wght@500;700&family=Quicksand:wght@300;400;500;700&family=Roboto:wght@400;500&display=swap"
		rel="stylesheet">
	<script>(function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f); })(window, document, 'script', 'dataLayer', 'GTM-KB72W5J');</script>

</head>
<noscript>
	<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KB72W5J" height="0" width="0" class="hideIt"></iframe>
</noscript>

<!-- End Google Tag Manager (noscript) -->

<body>
	<div class="sticky">
		<header class="header">
			<div class="shell shell--size-1" style="padding-top: 0px">
				<div class="header__inner">
					<a href="#home" class="logo" style="width: 30rem">
						<img src="assets/img/Cosmic Algorithm Brand Assets-10.png" alt="Cosmic Algorithm Logo"
							loading="lazy">
					</a>

					<div class="header__aside">
						<nav class="nav hidden-xs">
							<ul>
								<li>
									<a href="#home">Home</a>
								</li>

								<li>
									<a href="#about" [class.hovered]="scrolledToElement.reachedThree"
										[class.nothovered]="scrolledToElement.notreached">About</a>
								</li>
								<!-- Home / About / Academy / Newsletter / Brochure -->
								<li>
									<!-- <a onClick="document.location='/#etoroLoc';">eToro</a> -->
									<a [routerLink]="['/academy']" (click)="capturePos()">Academy</a>

								</li>

								<li>
									<!-- <a onClick="document.location='/#backtesting';">Backtesting</a> -->

									<a href="#performance" [class.hovered]="scrolledToElement.reachedEtoro"
										[class.nothovered]="scrolledToElement.notreached">Performance</a>
								</li>

								<li>

									<a href="#brochure" [class.hovered]="scrolledToElement.reachedBrochure"
										[class.nothovered]="scrolledToElement.notreached">Brochure</a>
								</li>

							</ul>
						</nav><!-- /.nav -->

						<div class="header__actions">
							<button class="btn btn--secondary hidden-xs"><a style="all: unset;"
									href="https://www.interactivebrokers.co.uk/portal/?action=ACCT_MGMT_MAIN&loginType=1&clt=0&locale=en_US&RL=1#/">My
									Profile</a></button>

							<a [routerLink]="['/etoro']" class="btn btn--size-1" (click)="capturePos()">Live</a>

							<a href="https://www.interactivebrokers.co.uk/portal/?action=ACCT_MGMT_MAIN&loginType=1&clt=0&locale=en_US&RL=1#/"
								class="btn btn--secondary btn--xs hidden visible-xs-inline-block">
								<img src="assets/img/svg/ico-profile.svg" alt="Click here for your profile"
									loading="lazy">
							</a>


						</div><!-- /.header__actions -->

					</div><!-- /.header__aside -->
				</div><!-- /.header__inner -->
			</div><!-- /.shell -->
		</header><!-- /.header -->
	</div>
	<script src="assets/vendor/jquery-3.6.0.min.js"></script>
	<script src="assets/js/bundle.js"></script>
	<div class="wrapper">

		<div class="hero" id="home">
			<div class="shell shell--size-2">
				<nav class="nav hidden visible-xs-block">
					<ul>
						<li>
							<a [routerLink]="['/home']">Home</a>
						</li>

						<li>
							<a href="#about">About</a>
						</li>

						<li>
							<!-- <a onClick="document.location='/#etoroLoc';">eToro</a> -->
							<a [routerLink]="['/academy']">Academy</a>
						</li>

						<li>
							<!-- <a onClick="document.location='/#backtesting';">Backtesting</a> -->
							<a href='/#performance'>Performance</a>
						</li>

						<li>
							<a href="#brochure">Brochure</a>
						</li>

					</ul>
				</nav><!-- /.nav -->
				<div class="hero__media">
					<button data-bs-toggle="modal" data-bs-target="#myModal" style="    
					background: none;
					border: none;
					padding: 0;
					width: 100%;
					height: 100%;" *ngIf="mobile">
						
						<div class="hero__image heroImg"></div><!-- /.hero__image -->

						<p class="hero__play js-play" target="_blank">
							<img src="assets/img/svg/ico-play.svg" alt="Play button">
						</p>
						<!-- /.hero__media -->
					</button>
					<button data-bs-toggle="modal" data-bs-target="#myModal" *ngIf="!mobile">
						
						<div class="hero__image heroImg"></div><!-- /.hero__image -->

						<p class="hero__play js-play" target="_blank">
							<img src="assets/img/svg/ico-play.svg" alt="Play button">
						</p>
						<!-- /.hero__media -->
					</button>
				</div>

				<div class="hero__content" *ngIf="!mobile">
					<h1 id="title" class="simplifiedDesk">Online Investment Trading Platform</h1>

					<ul>
						<li class="wow fadeInUp" data-wow-delay=".5s">
							<img src="assets/img/svg/ico-check.svg" alt="Check mark" class="hidden-xs" loading="lazy">

							<img src="assets/img/svg/ico-check-mobile.svg" alt="Check mark" loading="lazy"
								class="hidden visible-xs-block">

							No trading experience required
						</li>

						<li class="wow fadeInUp" data-wow-delay="1.5s">
							<img src="assets/img/svg/ico-check.svg" alt="Check mark" class="hidden-xs" loading="lazy" />

							<img src="assets/img/svg/ico-check-mobile.svg" alt="Check mark" loading="lazy"
								class="hidden visible-xs-block">

							Cosmic Algorithm trades for you
						</li>

						<li class="wow fadeInUp" data-wow-delay="2.5s">
							<img src="assets/img/svg/ico-check.svg" alt="Check mark" class="hidden-xs" loading="lazy">

							<img src="assets/img/svg/ico-check-mobile.svg" alt="Check mark" loading="lazy"
								class="hidden visible-xs-block">

							Minimum Fund Size - €250K
						</li>
					</ul>
				</div><!-- /.hero__content -->
				<div class="hero__content" *ngIf="mobile">
					<h1 id="title" class="simplifiedMob">Online Investment Trading Platform</h1>

					<ul>
						<li class="wow fadeInUp" data-wow-delay=".5s">
							<img src="assets/img/svg/ico-check.svg" alt="Check mark" class="hidden-xs" loading="lazy">

							<img src="assets/img/svg/ico-check-mobile.svg" alt="Check mark" loading="lazy"
								class="hidden visible-xs-block">

							No trading experience required
						</li>

						<li class="wow fadeInUp" data-wow-delay="1.5s">
							<img src="assets/img/svg/ico-check.svg" alt="Check mark" class="hidden-xs" loading="lazy">

							<img src="assets/img/svg/ico-check-mobile.svg" alt="Check mark" loading="lazy"
								class="hidden visible-xs-block">

							Cosmic Algorithm trades for you
						</li>

						<li class="wow fadeInUp" data-wow-delay="2.5s">
							<img src="assets/img/svg/ico-check.svg" alt="Check mark" class="hidden-xs" loading="lazy">

							<img src="assets/img/svg/ico-check-mobile.svg" alt="Check mark" loading="lazy"
								class="hidden visible-xs-block">

							Minimum Fund Size - €250K
						</li>
					</ul>
				</div><!-- /.hero__content -->
			</div><!-- /.shell -->
		</div><!-- /.hero -->
		<span scrolledTo #scrolledToElement="scrolledTo" id="threeReasons"></span>
		<section class="section section--primary" style="padding: 30px 0px 5px">
			<div class="shell shell--size-4">
				<div class="section__background"></div><!-- /.section__background -->

				<div class="section__foot" id="about" *ngIf="!mobile">
					<div class="section__foot-background"></div><!-- /.section__foot-background -->

					<h6>Robust logic</h6>

					<h5 class="colorBlack">Our algorithm is based on a Risk / Return Model which is moderate targeting
						a 15-25% gain for
						you annually.</h5>

				</div><!-- /.section__foot -->
				<div class="section__foot" *ngIf="mobile">
					<div class="section__foot-background"></div><!-- /.section__foot-background -->

					<h6>Robust logic</h6>

					<h5 class="colorBlack" style="margin-bottom: 0px;">Our algorithm is based on a Risk / Return Model
						which is moderate targeting
						a 15-25% gain for
						you annually.</h5>

				</div><!-- /.section__foot -->
			</div><!-- /.shell -->
		</section><!-- /.section -->
		<br /><br />
		<section class="section-image">
			<div class="shell">
				<div class="section__image imageSection"></div>
				<!-- /.section__image -->

				<div class="section__content wow fadeInUp">
					<img src="assets/img/svg/ico-award.svg" alt="Award" loading="lazy" />


					<h3 class="howItWorks">How it works
						<a (click)="etoroInf(6)" id="HowItWorks"><i
								class="fa-solid fa-circle-info fa-lg howItWorksi" placement="top" ngbTooltip="Read More"
								tooltipClass="toolTips"></i></a>

					</h3>

					<ul *ngIf="!mobile" style="margin-bottom: 0rem">
						<button (click)="etoroInf(2)" id="SmartStock" type="button" class="landingBtn btn-primary">
							<li>
								<img src="assets/img/svg/ico-list-1.svg" alt="Item 1" loading="lazy" />

								<h5>Smart Stock Curation</h5>

								<p style="color: black">It analyses all stock trading on the NASDAQ-100 Index, from
									there it selects the Top 20
									to
									trade on a monthly rotation.</p>
							</li>
						</button>

						<br /><br />

						<button (click)="etoroInf(3)" id="SmartStock" type="button" class="landingBtn btn-primary">
							<li>
								<img src="assets/img/svg/ico-list-2.svg" alt="Item 2" loading="lazy">

								<h5>Advanced Analytics & Intelligence</h5>

								<p style="color: black">Each month the algorithm updates the Top 20 for the coming
									month. Selecting the Top 20
									provides diversification within the portfolio.</p>
							</li>
						</button>

						<br /><br />

						<button (click)="etoroInf(4)" id="SmartStock" type="button" class="landingBtn btn-primary">
							<li>
								<img src="assets/img/svg/ico-list-3.svg" alt="Item 3" loading="lazy">

								<h5>Diversified Approach</h5>

								<p style="color: black">This diversification reduces risk exposure whilst targeting
									a net-profit of 15 – 25%.</p>
							</li>
						</button>
					</ul>

					<ul *ngIf="mobile" style="margin-bottom: 0rem">
						<button (click)="etoroInf(2)" id="SmartStock" type="button" class="landingBtn btn-primary">
							<li class="padTopMobileButton">
							
								<img src="assets/img/svg/ico-list-1.svg" alt="Item 1" loading="lazy" />

								<h5 style="line-height: 96%">Smart Stock Curation</h5>

								<p style="color: black">It analyses all stock trading on the NASDAQ-100 Index, from
									there it selects the Top 20
									to
									trade on a monthly rotation.</p>
						   
							</li>
						</button>

						<br /><br />

						<button (click)="etoroInf(3)" id="SmartStock" type="button" class="landingBtn btn-primary">
							<li class="padTopMobileButton">
							  
								<img src="assets/img/svg/ico-list-2.svg" alt="Item 2" loading="lazy">

								<h5 style="line-height: 96%">Advanced Analytics & Intelligence</h5>

								<p style="color: black">Each month the algorithm updates the Top 20 for the coming
									month. Selecting the Top 20
									provides diversification within the portfolio.</p>
						  
							</li>
						</button>

						<br /><br />

						<button (click)="etoroInf(4)" id="SmartStock" type="button" class="landingBtn btn-primary">
							<li class="padTopMobileButton">
						   
								<img src="assets/img/svg/ico-list-3.svg" alt="Item 3" loading="lazy">

								<h5 style="line-height: 96%">Diversified Approach</h5>

								<p style="color: black">This diversification reduces risk exposure whilst targeting
									a net-profit of 15 – 25%.</p>
						  
							</li>
						</button>

						<li style="margin-top: 2rem">
							<a (click)="etoroInf(1)" id="Etoro"><img src="assets/img/IBKR-Mobile.png" loading="lazy"
								alt="Click here for more eToro information" class="etoroBtnHowDesk"
								style="max-width: 50vw; margin-top: 1vh;"></a>
						</li>
					</ul>

					<div *ngIf="!mobile">
						<a (click)="etoroInf(1)" id="Etoro"><img src="assets/img/IBKR-Mobile.png" loading="lazy"
							alt="Click here for more eToro information" class="section__icon etoroBtnHowDesk"
							style="max-width: 9vw"></a>
					</div>
					<!-- <div *ngIf="mobile" class="etoroBtnPosMob">
						<a (click)="etoroInf(1)" id="Etoro"><img src="assets/img/svg/section-icon-1.svg" loading="lazy"
								alt="Click here for more eToro information" class="etoroBtnHowDesk"></a>
					</div> -->

				</div><!-- /.section__content -->
			</div><!-- /.shell -->
		</section>
		<section class="section mainSpacing" #screen id="mainGraph" style="height: 70vh;">
			<div class="shell shell--size-3" style="height: 100%">
				<br />
				<div class="row chart" id="chartSize">
					<div class="col">
						<!-- <div class="chart__head hidden-xs"> -->
						<div class="chart__head">
							<div class="chart__head-content">
								<!-- <h6>eToro Analysis</h6> -->

								<h6>Cosmic Algorithm Ltd.</h6>

								<span style="font-size: x-small" *ngIf="mobile">LIVE: {{DynamUpd}}</span><br />
								<span style="font-size: small" *ngIf="!mobile">LIVE: {{DynamUpd}}</span><br />
								<!-- <span>Last Updated: {{updateRecent}}</span> -->
							</div><!-- /.chart__head-content -->

						</div><!-- /.chart__head -->
					</div>
					<div *ngIf="!mobile" class="col legendGrad legendShadow" id="legend">
						<div id="legendItems">
							<div class="row margBottomLegend">
								<div class="col">AGR +/- (Since Oct 2022)</div>
								<div class="col"><span id="tLaunch"><span *ngIf="lPos">+</span>{{last}}%</span>
								</div>
							</div>
							<div class="row margBottomLegend">
								<div class="col">Gain +/- (Since Oct 2022)</div>
								<div class="col"><span id="tNSDQ"><span *ngIf="nPos">+</span>{{perfLaunch}}%</span></div>
							</div>
						</div>
					</div>
				</div>
				<div *ngIf="mobile" class="row legendGrad legendShadow" id="legend" style="width: 93%;margin: auto;">
					<div id="legendItems">
						<div class="row margBottomLegend">
							<div class="col">AGR +/- (Since Oct 2022)</div>
							<div class="col-auto legendPadMob"><span id="tLaunch"><span
										*ngIf="lPos">+</span>{{last}}%</span></div>
						</div>
						<div class="row margBottomLegend">
							<div class="col">Gain +/- (Since Oct 2022)</div>
							<div class="col-auto legendPadMob"><span id="tNSDQ"><span
										*ngIf=nPos>+</span>{{perfLaunch}}%</span></div>
						</div>
					</div>
				</div>
				<br />
				<div class="row chart" style="height: 100%">
					<div class="chart__body" class="wow fadeInRight" data-wow-delay=".5s" id="chart"
						style="height: 100%">
						<div id="container" class="textCenter">
						</div><!-- /.chart__body -->
					</div>
				</div>
			</div><!-- /.shell -->
		</section>

		<div style="text-align: center; font-size:smaller" *ngIf="!mobile">Past performance is not an indication of
			future results.<br /></div>
		<div style="text-align: center; margin-left: 2vw; font-size: smaller;" *ngIf="mobile">Past performance is not an
			indication of future results.</div><br /><br />
		<br />
		<a class="readMoreFlex" [routerLink]="['/etoro']" (click)="capturePos()">Read More - News Feed</a><br /><br />

		<section class="linkedIn">
			<div class="shell">
				<div class="section__content">
					<a href="https://www.linkedin.com/company/cosmic-algorithm-limited/" target="_blank"
						rel="noopener noreferrer"><img class="linkedImg"
							src="../../assets/img/Follow Us on LinkedIn.png" alt="Follow us on LinkedIn"
							loading="lazy" /></a>
				</div>
			</div>
		</section>

		<section class="section" style="height: 70vh" #nsdq id="performance" scrolledTo #scrolledToElement="scrolledTo" style="margin-bottom: 0.5rem">
			<div class="shell shell--size-3" style="height: 100%">
				<app-main-portfolio></app-main-portfolio>
			</div>
		</section>
		<a class="readMoreFlex" [routerLink]="['/etoro']" (click)="capturePos()">Read More - News Feed</a>
		<br /><br />
		<div class="callout" style="margin-top: 2%; margin-bottom: 4%" *ngIf="!mobile">
			<div class="shell" class="wow fadeInLeft" data-wow-delay=".2s">
				<div class="callout__inner">
					<div class="callout__content">
						<h2>Invite a friend</h2>

						<p>Algorithmically Traded Wealth Generation.</p>
					</div><!-- /.callout__content -->
					<ng-template #content let-modal>
						<!-- <div class="modal-header referHeader">
							<h4 class="modal-title referTitle" id="modal-basic-title">
								Refer a Friend</h4>
							<button type="button" class="close" aria-label="Close"
								(click)="modal.dismiss('Cross click')">
								<span aria-hidden="true">&times;</span>
							</button>
						</div> -->
						<div class="modal-body referBody">
							<h4 class="modal-title referTitle" id="modal-basic-title">
								Refer a Friend</h4>
								<form style="display: flex;
								flex-direction: column;
								align-content: center;
								align-items: center;">
								<br />
								<div class="form-group groupCol">
									<label for="fname_referer" class="referText">Name</label>
									<div class="input-group">
										<input type="text" class="form-control" name="fname_referer" id="fname_referer"
											aria-describedby="firstName" placeholder="Enter your name"
											(input)="yourName=$event.target.value">
									</div>
								</div>
								<br />
								<div class="form-group groupCol">
									<label for="email_referer" class="referText">Email</label>
									<div class="input-group">
										<input type="email" class="form-control" name="email_referer" id="email_referer"
											aria-describedby="emailHelp" placeholder="Enter your email"
											(input)="yourEmail=$event.target.value">
									</div>
								</div>
								<br />
								<div class="form-group groupCol">
									<label for="friend_name" class="referText">Friend's
										name</label>
									<div class="input-group">
										<input type="text" class="form-control" name="friend_name" id="friend_name"
											placeholder="Enter friend's name" (input)="friendsName=$event.target.value">
									</div>
								</div>
								<br />
								<div class="form-group groupCol" id="referFooting">
									<label for="friend_email" class="referText">Friend's
										email</label>
									<div class="input-group">
										<input type="email" class="form-control" name="friend_email" id="friend_email"
											aria-describedby="emailHelp" placeholder="Enter friend's email"
											(input)="friendsEmail=$event.target.value">
									</div>
								</div>
							</form>
							<button type="button" class="btn btn-outline-dark footerSubmit joinUsBtn"
								(click)="modal.close('Save click')">Submit</button>
						</div>
						<!-- <div class="modal-footer footerRefer">
							<button type="button" class="btn btn-outline-dark footerSubmit"
								(click)="modal.close('Save click')">Submit</button>
						</div> -->
					</ng-template>
					<div class="callout__actions">
						<button class="btn btn--size-3" (click)="open(content)">Invite</button>
					</div><!-- /.callout__actions -->
				</div><!-- /.callout__inner -->
			</div><!-- /.shell -->
		</div><!-- /.callout -->
		<div class="callout" style="margin-left: 4%; margin-right: 4%" *ngIf="mobile">
			<div class="shell" class="wow fadeInLeft" data-wow-delay=".2s">
				<div class="callout__inner">
					<div class="callout__content">
						<h2>Invite a friend</h2>

						<p>Algorithmically Traded Wealth Generation.</p>
					</div><!-- /.callout__content -->
					<ng-template #content let-modal>
						<!-- <div class="modal-header referHeader">
							<h4 class="modal-title referTitle" id="modal-basic-title">
								Refer a Friend</h4>
							<button type="button" class="close" aria-label="Close"
								(click)="modal.dismiss('Cross click')">
								<span aria-hidden="true">&times;</span>
							</button>
						</div> -->
						<div class="modal-body referBody">
							<h4 class="modal-title referTitle" id="modal-basic-title">
								Refer a Friend</h4>
								<form style="display: flex;
								flex-direction: column;
								align-content: center;
								align-items: center;">
								<br />
								<div class="form-group groupCol">
									<label for="fname_referer" class="referText">Name</label>
									<div class="input-group">
										<input type="text" class="form-control" name="fname_referer" id="fname_referer"
											aria-describedby="firstName" placeholder="Enter your name"
											(input)="yourName=$event.target.value">
									</div>
								</div>
								<br />
								<div class="form-group groupCol">
									<label for="email_referer" class="referText">Email</label>
									<div class="input-group">
										<input type="email" class="form-control" name="email_referer" id="email_referer"
											aria-describedby="emailHelp" placeholder="Enter your email"
											(input)="yourEmail=$event.target.value">
									</div>
								</div>
								<br />
								<div class="form-group groupCol">
									<label for="friend_name" class="referText">Friend's
										name</label>
									<div class="input-group">
										<input type="text" class="form-control" name="friend_name" id="friend_name"
											placeholder="Enter friend's name" (input)="friendsName=$event.target.value">
									</div>
								</div>
								<br />
								<div class="form-group groupCol" id="referFooting">
									<label for="friend_email" class="referText">Friend's
										email</label>
									<div class="input-group">
										<input type="email" class="form-control" name="friend_email" id="friend_email"
											aria-describedby="emailHelp" placeholder="Enter friend's email"
											(input)="friendsEmail=$event.target.value">
									</div>
								</div>
							</form>
							<button type="button" class="btn btn-outline-dark footerSubmit joinUsBtn"
								(click)="modal.close('Save click')">Submit</button>
						</div>
						<!-- <div class="modal-footer footerRefer">
							<button type="button" class="btn btn-outline-dark footerSubmit"
								(click)="modal.close('Save click')">Submit</button>
						</div> -->
					</ng-template>
					<div class="callout__actions">
						<button class="btn btn--size-3" (click)="open(content)">Invite</button>
					</div><!-- /.callout__actions -->
				</div><!-- /.callout__inner -->
			</div><!-- /.shell -->
		</div><!-- /.callout -->
	
		<section class="section" style="height: 70vh" #exe id="exe">
			<div class="shell shell--size-3" style="height: 100%">
				<br />
				<div class="row chart" id="chartSize">
					<div class="col">
						<!-- <div class="chart__head hidden-xs"> -->
						<div class="chart__head">
							<div class="chart__head-content">
								<h6>Trade Executions</h6>

								<!-- <h5>Cummulative Performance Gain as at 30 November 2023</h5> -->
								<span style="font-size: x-small" *ngIf="mobile">UPDATED:
									{{lastDate}}</span><br />
								<span style="font-size: small" *ngIf="!mobile">UPDATED:
									{{lastDate}}</span><br />
								<!-- <span>Last Updated: {{updateRecent}}</span> -->
							</div><!-- /.chart__head-content -->

						</div><!-- /.chart__head -->
					</div>
					<div *ngIf="!mobile" class="col legendGrad legendShadow" id="legend">
						<div id="legendItems">
							<div class="row margBottomLegend" style="display: none;">
								<div class="col">AGR - 2021 (Traded Gain)</div>
								<div class="col"><span id="tGain"><span *ngIf="gPos">+</span>{{tGain}}%</span> </div>
							</div>
							<div class="row margBottomLegend">
								<div class="col">AGR +/- (Since Oct 2022)</div>
								<div class="col">
									<span id="tLaunch" *ngIf="last >= 0" style="color: green">
										<span *ngIf="lPos">+</span>{{last}}%
									</span>
									<span id="tLaunch" *ngIf="last < 0" style="color: red">
										<span *ngIf="lPos">+</span>{{last}}%
									</span>
								</div>
							</div>
							<div class="row margBottomLegend">
								<div class="col">Net Asset Value +/-</div>
								<div class="col">
									<span id="netasset" *ngIf="netAsset >= 0" style="color: green">
										+{{netAsset}}%
									</span>
									<span id="netasset" *ngIf="netAsset < 0" style="color: red">
										{{netAsset}}%
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div *ngIf="mobile" class="row legendGrad legendShadow" id="legendExe" style="width: 93%;margin: auto;">
					<div id="legendItems">
						<div class="row margBottomLegend" style="display: none;">
							<div class="col">AGR - 2021 (Traded Gain)</div>
							<div class="col-auto legendPadMob"><span id="tGain"><span
										*ngIf="gPos">+</span>{{tGain}}%</span> </div>
						</div>
						<div class="row margBottomLegend">
							<div class="col">AGR +/- (Since Oct 2022)</div>
							<div class="col-auto legendPadMob">
								<span id="unrealised" *ngIf="agrGAIN >= 0" style="color: green">+{{agrGAIN}}%</span>
								<span id="unrealised" *ngIf="agrGAIN < 0" style="color: #EE4B2B">{{agrGAIN}}%</span>
							</div>
						</div>
						<div class="row margBottomLegend">
							<div class="col">Net Asset Value +/- (Since Oct 2022)</div>
							<div class="col-auto legendPadMob"><span id="netasset"><span
										*ngIf="netAssetPos">+</span>{{netAsset}}%</span></div>
						</div>
					</div>
				</div>
				<br />
				<div class="row chart" style="height: 100%">
					<div class="chart__body" class="wow fadeInRight" data-wow-delay=".5s" id="chart"
						style="height: 100%">
						<div id="exeContainer" class="textCenter">
						</div><!-- /.chart__body -->
					</div>
				</div>
			</div><!-- /.shell -->
		</section>
		<!-- <div>
			<section class="section">
				<div class="shell shell--size-3">
					<div class="section__head">
						<h6>Algorithm</h6>

						<h2>Trade Executions</h2>
					</div>
				</div>
				<div class="graphSizes">
					<div class="exeDesk" id="executionsPlot"></div><br />
				</div>
			</section>
			
		</div> -->
		<br /><br /><br /><br /><br /><br /><br /><br /><br />
		<a class="readMoreFlex" [routerLink]="['/etoro']" (click)="capturePos()">Read More - News Feed</a>

		<section class="section-circles" *ngIf="!mobile" id="bubbles">
			<div class="shell shell--size-5">
				<div class="section__inner">
					<div class="section__head">
						<h4 class="circlesTitle">Method</h4>

						<h4 class="wow fadeInRight" data-wow-delay=".2s">Cosmic Algorithm summarily lists the
							analytical methodologies for this algorithm</h4>
					</div><!-- /.section__head -->

					<div class="section__content">
						<ul>
							<li class="wow fadeInRight" data-wow-delay=".2s">
								<img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

								Runs on daily candles
							</li>

							<li class="wow fadeInRight" data-wow-delay=".2s">
								<img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

								Absolute momentum quantification mechanism based on 13612 weighted filter
							</li>

							<li class="wow fadeInRight" data-wow-delay=".2s">
								<img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

								Relative momentum ranking and weight allocation system
							</li>

							<li class="wow fadeInRight" data-wow-delay=".2s">
								<img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

								Support for stock and ETF portfolios
							</li>

							<li class="wow fadeInRight" data-wow-delay=".2s">
								<img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

								Support for leveraged & unleveraged accounts
							</li>

							<li class="wow fadeInRight" data-wow-delay=".2s">
								<img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

								Adjustable rebalance period
							</li>
							<li class="wow fadeInRight" data-wow-delay=".2s">
								<a (click)="etoroInf(5)" id="Methodology">
									<i [class.hovered]="scrolledToElement.reachedBubbles"
										class="fa-solid fa-circle-info fa-3x circlesI" placement="top"
										ngbTooltip="Read More" tooltipClass="toolTips" scrolledTo
										#scrolledToElement="scrolledTo">
									</i></a>
							</li>
						</ul>
					</div><!-- /.section__content -->

					<div class="section__foot" style="display: flex;
    				align-items: center;">
						<div>
							<h6 class="wow fadeInRight white" data-wow-delay=".2s">Minimum Fund Size </h6>

							<h2 class="wow fadeInRight white" data-wow-delay=".2s">€250K</h2>


							<br />
							<div style="font-size: smaller;
								margin-top: 1vh;
								width: 100%;" class="wow fadeInRight white" data-wow-delay=".2s">
								<div style="padding-left: 10%;padding-right: 10%;">Past performance is not an indication
									of future results.</div>
							</div>
						</div>
					</div><!-- /.section__foot -->
				</div><!-- /.section__inner -->
			</div><!-- /.shell -->
		</section><!-- /.section-circles -->

		<section class="section-circles" *ngIf="mobile" id="bubbles">
			<div class="shell shell--size-5">
				<div class="section__inner">
					<div class="section__head">
						<h4 class="circlesTitle">Method</h4>

						<h4 class="wow fadeInRight" data-wow-delay=".2s">Cosmic Algorithm summarily lists the
							analytical methodologies for this algorithm</h4>
					</div><!-- /.section__head -->

					<div class="section__content">
						<ul class="circlesMarg">
							<li class="wow fadeInRight" data-wow-delay=".2s">
								<img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

								Runs on daily candles
							</li>

							<li class="wow fadeInRight" data-wow-delay=".2s">
								<img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

								Absolute momentum quantification mechanism based on 13612 weighted filter
							</li>

							<li class="wow fadeInRight" data-wow-delay=".2s">
								<img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

								Relative momentum ranking and weight allocation system
							</li>

							<li class="wow fadeInRight" data-wow-delay=".2s">
								<img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

								Support for stock and ETF portfolios
							</li>

							<li class="wow fadeInRight" data-wow-delay=".2s">
								<img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

								Support for leveraged & unleveraged accounts
							</li>

							<li class="wow fadeInRight" data-wow-delay=".2s">
								<img src="assets/img/svg/ico-check-dark.svg" alt="Check mark" loading="lazy" />

								Adjustable rebalance period
							</li>
							<li>
								<a (click)="etoroInf(5)" class="circlesIMob" id="Methodology">
									<i [class.hovered]="scrolledToElement.reachedBubbles"
										class="fa-solid fa-circle-info fa-3x circlesIMob2" scrolledTo
										#scrolledToElement="scrolledTo">
									</i></a>
							</li>
						</ul>
					</div><!-- /.section__content -->

					<div class="section__foot footerSize" style="display: flex;
    				align-items: center;">
						<div>

							<h6 class="wow fadeInRight white" data-wow-delay=".2s">Minimum Fund Size </h6>

							<h2 class="wow fadeInRight white" data-wow-delay=".2s">€250K</h2>
		
							<div style="text-align: center; font-size: smaller;" class="wow fadeInRight white" data-wow-delay=".2s"><br/>Past performance is not an indication of future results.</div>
						</div>
					</div><!-- /.section__foot -->
				</div><!-- /.section__inner -->
			</div><!-- /.shell -->
		</section><!-- /.section-circles -->
		<div *ngIf="!mobile">
			<section class="section" id="backtesting">
				<div class="shell shell--size-6">
					<div class="box">
						<div class="grid">
							<div class="grid__col grid__col--size-1">
								<div class="box__image">
									<img src="assets/img/temp/box-img-1.jpg" loading="lazy"
										alt="Plot of the Backseat-Trader algorithm's backtesting results through the development phase">

								</div><!-- /.box__image -->

							</div><!-- /.grid__col -->

							<div class="grid__col grid__col--size-2">
								<div class="box__content">
									<h6>Backtesting</h6>

									<h2 class="white">Feasibility Analysis 27% Annualised Return</h2>

									<p class="wow fadeInUp" data-wow-delay=".5s">This summary page presents an outline
										of
										the approach Cosmic Algorithm Ltd (CAL) undertook when developing the
										Backseat-Trader algorithm.</p>

									<p class="wow fadeInUp" data-wow-delay=".6s">{{backtestingText}} is a comparison
										between the algorithm's historical equity curve versus the value of SPY, QQQ,
										and
										SPY-AGG 70/30 portfolio equity curves. All systems are rebalanced monthly with
										US$10,000 initial investment. There is no capital reinvestment assumed.</p>

									<p class="wow fadeInUp" data-wow-delay=".7s">CAL can supply the back-testing data
										used
										in electronic format, upon request.</p>

									<p class="wow fadeInUp" data-wow-delay=".8s">A momentum-based semi-automated stock
										rotation system. Only long positions are traded. The system tracks NASDAQ index
										components on a daily basis and selects the top 20 best performing stocks of the
										index. The selection is rebalanced once per month which increases return and
										reduces
										volatility.</p>
								</div><!-- /.box__content -->
							</div><!-- /.grid__col -->
						</div><!-- /.grid -->
					</div><!-- /.box -->
				</div><!-- /.shell -->
			</section><!-- /.section -->
			<br /><br />
		</div>
		<div *ngIf="mobile">
			<section class="section" id="backtesting">
				<div class="shell shell--size-6">
					<div class="box">
						<div class="grid">
							<div class="grid__col grid__col--size-1">
								<div class="box__image" style="background-color: white;     
								width: 100vw;
								margin-left: -4%;">
									<img src="assets/img/temp/box-img-1.jpg" loading="lazy"
										alt="Plot of the Backseat-Trader algorithm's backtesting results through the development phase">
	
										
									
								</div><!-- /.box__image -->
	
							</div><!-- /.grid__col -->
	
							<div class="grid__col grid__col--size-2">
								<div class="box__content">
									
									<h6>Backtesting</h6>
	
									<h2 class="white">Feasibility Analysis 27% Annualised Return</h2>
	
									<p class="wow fadeInUp" data-wow-delay=".5s">This summary page presents an outline of
										the approach Cosmic Algorithm Ltd (CAL) undertook when developing the
										Backseat-Trader algorithm.</p>
	
									<p class="wow fadeInUp" data-wow-delay=".6s">{{backtestingText}} is a comparison
										between the algorithm's historical equity curve versus the value of SPY, QQQ, and
										SPY-AGG 70/30 portfolio equity curves. All systems are rebalanced monthly with
										US$10,000 initial investment. There is no capital reinvestment assumed.</p>
	
									<p class="wow fadeInUp" data-wow-delay=".7s">CAL can supply the back-testing data used
										in electronic format, upon request.</p>
	
									<p class="wow fadeInUp" data-wow-delay=".8s">A momentum-based semi-automated stock
										rotation system. Only long positions are traded. The system tracks NASDAQ index
										components on a daily basis and selects the top 20 best performing stocks of the
										index. The selection is rebalanced once per month which increases return and reduces
										volatility.</p>
								</div><!-- /.box__content -->
							</div><!-- /.grid__col -->
						</div><!-- /.grid -->
					</div><!-- /.box -->
				</div><!-- /.shell -->
			</section><!-- /.section -->
		</div>

		<section class="section-secondary" id="brochure" scrolledTo #scrolledToElement="scrolledTo" style="margin-top: 0px">
			<div class="shell shell--size-7">
				<div class="section__inner">
					<div class="section__background"></div><!-- /.section__background -->

					<div class="section__image" class="wow fadeInUp" data-wow-delay=".5s">
						<div class="brochurePos">
							<img src="assets/img/temp/section-img-2.png" loading="lazy"
								alt="Image of Backseat-Trader algorithm's brochure">
						</div>
					</div><!-- /.section__image -->

					<div class="section__content">
						<h3>Algorithmic trading handbook on trading without trading.</h3>

						<p>Take a copy of the brochure to review and share</p>
						<!-- 
						<a href="https://drive.google.com/uc?export=download&id=1bIO4A-rcZLejbLXYVn-M0A_DBQQMz8TI" class="btn btn--dark">Download Now</a> -->
						<div *ngIf="!loading">
							<a href="https://drive.google.com/file/d/1UJoMYFBVQtwMAzv5j0Uq-Fr8cj4HcJJN/view" target="_blank" class="btn btn--dark">Download Now</a>
						</div>
						<div *ngIf="loading">
							<div *ngIf="loading" class="text-center">
								<div class="spinner-grow text-primary" role="status">
									<span class="sr-only">Loading...</span>
								</div>
							</div>
						</div>
					</div><!-- /.section__content -->
				</div><!-- /.section__inner -->
			</div><!-- /.shell -->
		</section><!-- /.section-secondary -->
	</div><!-- /.wrapper -->

	<div class="modal" id="myModal">
		<div class="modal-dialog modal-fullscreen">
			<div class="modal-content">


				<div class="modal-body">
					<video height="95%" width="100%" controls #homeVideo>
						<source src="https://theapi.cosmic-algorithm.ie/Introducing-IBKR.mp4" type="video/mp4">
					</video>
				</div>

				<!-- Modal footer -->
				<div class="modal-footer" style="    margin: auto;
				margin-bottom: 1%;
				margin-top: -1%;">
					<button type="button" class="btn btn-danger" data-bs-dismiss="modal"
						(click)="close(homeVideo)">Close</button>
				</div>

			</div>
		</div>
	</div>
	<div class="fb-like hideIt" data-href="https://www.facebook.com/backseattrader" data-width="" data-layout=""
		data-action="" data-size="" data-share="true"></div>

	<script src="assets/vendor/jquery-3.6.0.min.js"></script>
	<!--<script src="assets/js/bundle.js"></script>-->
</body>

</html>